/* eslint-disable @typescript-eslint/no-explicit-any */

import { container } from '@shared/common/dependency-injection/domain/container';
import type { CockpitApiErrorHandlerService } from '@shared/common/error/data/service/cockpit-api-error-handler.service';
import { ErrorDependencyTypes } from '@shared/common/error/error.dependency-types';

export function wrapCockpitApiError() {
  return (_target: any, _propertyKey: string, descriptor: PropertyDescriptor): void => {
    const wrappedFunction = descriptor.value;
    descriptor.value = async function (...args: any[]) {
      const apiErrorHandler = container.get<CockpitApiErrorHandlerService>(
        ErrorDependencyTypes.CockpitApiErrorHandlerService,
      );

      try {
        const result = wrappedFunction.apply(this, args);
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          return await result;
        }

        return result;
      } catch (error: unknown) {
        throw apiErrorHandler.handle(error);
      }
    };
  };
}
